import { render } from "./TheInputCheck.vue?vue&type=template&id=56f08519"
import script from "./TheInputCheck.vue?vue&type=script&lang=js"
export * from "./TheInputCheck.vue?vue&type=script&lang=js"

import "./TheInputCheck.vue?vue&type=style&index=0&id=56f08519&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__